// eslint-disable @typescript-eslint/camelcase

import axios from 'axios';
import { Auth } from '@/utils';

import { getEnv } from '@/utils';

const { GO_ENDPOINT, SITE_TYPE } = getEnv();

async function getAllShippingCosts(shippingInfoId, saleId) {
  try {
    const token = await Auth.getIdToken();
    const response = await axios
      .create({
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sale_id: saleId,
          shipping_info_id: shippingInfoId,
        },
      })
      .get(`${GO_ENDPOINT}/v1/${SITE_TYPE}/all_shipping_costs`);

    return response.data;
  } catch (error) {
    return error;
  }
}

export default getAllShippingCosts;
